import { render, staticRenderFns } from "./InventoryUnlinkedTagsCard.vue?vue&type=template&id=d2557370&"
import script from "./InventoryUnlinkedTagsCard.vue?vue&type=script&lang=js&"
export * from "./InventoryUnlinkedTagsCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryUnlinkedTagsCard.vue?vue&type=style&index=0&id=d2557370&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports